import React from 'react';
import { CapacityMetric, ORDERS_METRIC } from './production-capacity-editor.helpers';
import { colors, fontFamily } from './editor.styles';
import { CloseIcon, PlusIcon } from './icons';

interface MetricTabsProps {
  metrics: CapacityMetric[];
  activeKey: string;
  isAddOpen: boolean;
  onPick: (key: string) => void;
  onRemove: (key: string) => void;
  onToggleAdd: () => void;
  children?: React.ReactNode;
}

export const MetricTabs = ({ metrics, activeKey, isAddOpen, onPick, onRemove, onToggleAdd, children }: MetricTabsProps) => {
  return (
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
      <span style={{ fontSize: 12, fontWeight: 500, color: colors.muted }}>Limite affichée</span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, padding: 4, background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 10 }}>
          {metrics.map((metric) => {
            const isActive = metric.key === activeKey;

            return (
              <div
                key={metric.key}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: 7,
                  background: isActive ? colors.primary : 'transparent',
                  color: isActive ? '#FFFFFF' : colors.soft,
                }}>
                <button
                  type="button"
                  aria-pressed={isActive}
                  onClick={() => onPick(metric.key)}
                  style={{ height: 36, padding: '0 16px', border: 'none', borderRadius: 7, background: 'transparent', color: 'inherit', fontFamily, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  {metric.label}
                </button>

                {metric.key !== ORDERS_METRIC && (
                  <button
                    type="button"
                    aria-label={`Ne plus limiter ${metric.label}`}
                    onClick={() => onRemove(metric.key)}
                    style={{ width: 28, height: 36, marginLeft: -8, padding: 0, border: 'none', background: 'transparent', color: 'inherit', opacity: 0.75, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CloseIcon size={13} />
                  </button>
                )}
              </div>
            );
          })}
        </div>

        <button
          type="button"
          aria-expanded={isAddOpen}
          onClick={onToggleAdd}
          style={{ height: 46, padding: '0 14px', display: 'flex', alignItems: 'center', gap: 6, borderRadius: 10, border: '1px dashed rgba(63,182,232,0.6)', background: 'transparent', color: colors.accent, fontFamily, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          <PlusIcon size={15} />
          Catégorie
        </button>
      </div>

      {children}
    </div>
  );
};
